var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataRiskSuggestionPie = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.9521C2 8.00472 5.49742 4.27894 10.3066 3.93101C10.7147 3.90149 11.0476 4.23607 11.0476 4.64517V12.2113C11.0476 12.6204 11.3793 12.9521 11.7884 12.9521H19.3527C19.7625 12.9521 20.0972 13.2864 20.0686 13.6952C19.7191 18.6756 15.9846 21.9997 11.0476 21.9997C5.8609 21.9997 2 18.1515 2 12.9521Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2C18.1475 2.02829 22 6.05771 22 11H13V2Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataRiskSuggestionPie);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_risk_suggestion_pie.0cb360d9c15bafcb8a51df5e50137b09.svg";